import { render, staticRenderFns } from "./CatList.vue?vue&type=template&id=48c8b336&scoped=true&"
import script from "./CatList.vue?vue&type=script&lang=js&"
export * from "./CatList.vue?vue&type=script&lang=js&"
import style0 from "./CatList.vue?vue&type=style&index=0&id=48c8b336&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c8b336",
  null
  
)

export default component.exports